import React, { useEffect, useState } from 'react';
import { getLabel } from '../../InitData';
import { navigate } from '../../router/Link';
import { useLiveData } from '../../live/LiveDataProvider';
import { filterSearchResults, iconSportCssClass } from '../../data/utils';
import InfoMessage from '../InfoMessage';
import { getEventUrl } from '../../prematch/Prematch';
import PortalWrapper from '../PortalWrapper';
import { closeParentModal } from '../Modal';

export default function LiveResults(props) {
    const liveData = useLiveData();
    
    const [search, setSearch] = useState(null);

    function handleClick(e, event) {
        e.stopPropagation();
        navigate(getEventUrl(event));
        setSearch('');
        window.dispatchEvent(new CustomEvent('xs_openEvent', {detail: event}));
        closeParentModal(e);
    }

    useEffect(() => {
        function listener(e) {
            setSearch(e.detail);
        }

        window.addEventListener('xs_search', listener);
        return () => window.removeEventListener('xs_search', listener);
    }, []);
    
    if (search == null || search.length <= 3) {
        return null;
    }

    const filtered = filterSearchResults(liveData.matches, search, 'MATCH', (match) => match.desc);

    let component = null;
    if (filtered.length === 0) {
        component = (
            <div className="c_35">
                <InfoMessage text={getLabel('general.no_results')} />
            </div>
        );
    } else {
        component = (
            <div className="c_35">
                <div className="c_35_1">{getLabel('general.find')} {`(${filtered.length})`}</div>
                {filtered.map(e => {
                    const sport = liveData.sportById[e.sportRef];
                    const sportIcon = iconSportCssClass(sport.id, sport.iconClass);
    
                    return (
                        <div key={e.uniqueId} className="c_35_2" onClick={(event) => handleClick(event, e)}>
                            <div className="c_35_2_1">
                                <div className="c_35_2_1_1">
                                    <div className={"c_35_2_1_1_1 " + sportIcon}></div>
                                    <div className="c_35_2_1_1_2">{`${e.sportDesc} | ${e.categoryDesc} | ${e.tournamentDesc}`}</div>
                                </div>
                            </div>
                            <div className="c_35_2_2">{e.desc}</div>
                        </div>
                    );
                })}
            </div>
        );
    }

    if (props.portal) {
        return (
            <PortalWrapper container={props.portal}>
                <div className="c_63">
                    {component}
                </div>
            </PortalWrapper>
        );
    }

    return component;
}
